import { useDeleteTasks as _useDeleteTasks } from '@griply/hooks';
import { useCallback } from 'react';
import { useUpdateGoalMutation } from 'shared/hooks/queries/use-update-goal-mutation';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { getTasksByIds } from 'shared/services/backend-api';
import {
  ActionEvents,
  taskTypeToTrackingTaskType,
} from 'shared/services/tracking';
import { Task } from 'shared/types/task';

export const useDeleteTasks = () => {
  const track = useTrackEvents();
  const { mutateAsync: updateTasksAsync } = useUpdateTasksMutation();
  const { mutate: updateGoal } = useUpdateGoalMutation();

  const handleTaskDeleted = useCallback(
    (task: Task) => {
      track(ActionEvents.TaskDelete, {
        type: taskTypeToTrackingTaskType[task.type],
      });
    },
    [track],
  );

  return _useDeleteTasks({
    getTasksByIds,
    updateTasksAsync,
    updateGoal,
    onTaskDeleted: handleTaskDeleted,
  });
};
